import { Model, emptyModel } from "../types/Model";
import { ReactElement, useState } from "react";

import { ModelContext } from "./ModelContext";
import ModelDataService from "@kea-mod/common/axios/services/ModelDataService";

interface Props {
  children: ReactElement;
}
export const ModelContextProvider = (props: Props) => {
  const [models, setModels] = useState([]);
  const [model, setModel] = useState(emptyModel);

  const updateModels = async (exerciseId: number) => {
    return new Promise<Object>((resolve, reject) => {
      ModelDataService.getAll(exerciseId, "studentSolution")
        .then((response) => {
          if (response.data.success) {
            if (response.status !== 200) return;

            let models = response.data.data;
            setModels(models);
            setselectedModel(models);
            return resolve(models);
          } else {
            /** TODO SHOULD HANDLE UNSUCCESSFULL FETCHING EXERCISES HERE. */
            reject({});
          }
        })
        .catch((e) => {
          console.log(e);
        });
    });
  };
  const setselectedModel = (Models: Model[]) => {
    let m = 0;

    for (let i = 1; i < Models.length; i++) {
      if (Models[m].createdAt <= Models[i].createdAt) {
        m = i;
      }
    }

    if (Models[m]) {
      setModel(Models[m]);
    }
  };

  const createModel = async (data: any, exerciseId: number) => {
    return new Promise<Object>((resolve, reject) => {
      ModelDataService.create(data).then((response) => {
        if (response.data.success) {
          updateModels(exerciseId);
          return resolve(response.data.data);
        } else {
          /** TODO SHOULD HANDLE UNSUCCESSFULL FETCHING EXERCISES HERE. */
          reject({});
        }
      });
    });
  };

  const deleteModel = (id: any, exerciseId: number) => {
    ModelDataService.delete(id)
      .then((response) => {
        console.log(response);
        if (response.data.success) {
          updateModels(exerciseId);
        } else {
          /** TODO SHOULD HANDLE UNSUCCESSFULL DELETING MOdel HERE. */
        }
      })
      .catch((e) => {
        /** TODO SHOULD HANDLE ERROR DELETING MOdel. */
        console.warn(e);
      });
  };

  const updateModel = (id: any, data: any, exerciseId: number) => {
    ModelDataService.updateModel(id, data)
      .then((response) => {
        if (response.data.success) {
          updateModels(exerciseId);
        } else {
          /** TODO SHOULD HANDLE UNSUCCESSFULL DELETING ASSIGNMENT HERE. */
        }
      })
      .catch((e) => {
        /** TODO SHOULD HANDLE ERROR DELETING ASSIGNMENT. */
        console.warn(e);
      });
  };

  return (
    <ModelContext.Provider
      value={{
        models: models,
        model: model,
        create: createModel,
        update: updateModels,
        delete: deleteModel,
        updateModel: updateModel,
        setModel: setModel,
      }}
    >
      {props.children}
    </ModelContext.Provider>
  );
};
export default ModelContextProvider;
